import { Point } from './Point';
import { Rect } from './Rect';

export class Line {
  private _start: Point;
  private _end: Point;

  get start() {
    return this._start;
  }

  get end() {
    return this._end;
  }
  
  private constructor(
    start: Point,
    end: Point,
  ) {
    this._start = start;
    this._end = end;
  }

  static createEmpty() {
    return new Line(Point.createEmpty(), Point.createEmpty());
  }

  static create(start: Point, end: Point) {
    return new Line(start, end);
  }

  static createHorizontalLine(x: number, y: number, width: number) {
    return new Line(Point.create(x, y), Point.create(x + width, y));
  }

  static createVerticalLine(x: number, y: number, height: number) {
    return new Line(Point.create(x, y), Point.create(x, y + height));
  }

  clone() {
    return new Line(this._start.clone(), this._end.clone());
  }

  equals(line: Line) {
    return this._start.equals(line._start) && this._end.equals(line._end);
  }

  // todo: implement
  static merge(lines: Line[]): Line[] {
    if (lines.length === 0) {
      return [];
    }
    const result: Line[] = [];

    result.push(lines[0].clone());

    for (let i = 1; i < lines.length; i++) {
      const line = lines[i];
      
      // result.find((l) => line.)

    }


    return result;
  }

  toRect(): Rect {
    return Rect.create(
      this.start.x,
      this.start.y,
      this.end.x - this.start.x,
      this.end.y - this.start.y
    );
  }
}
